<script setup lang="ts">
import BatchTypesList from "@/scripts/components/app/qrcodes/batch/BatchTypesList.vue";
import {QrBatchType, QrTable} from "@/scripts/types/qr";
import {ref} from "vue";
import BatchLink from "@/scripts/components/app/qrcodes/batch/Type/BatchLink.vue";
import QrCodeStyle from "@/scripts/components/app/qrcodes/form/QrCodeStyle.vue";
import {qrCodeFormStore} from "@/scripts/store/qr_code_form.store.js";
import QrCodeView from "@/scripts/components/app/qrcodes/form/QrCodeView.vue";
import {ChevronDownIcon, ChevronUpIcon} from "@heroicons/vue/24/solid";
import Pixel from "@/scripts/components/app/qrcodes/form/destination/extensions/Pixel.vue";
import VButton from "@/scripts/components/app/common/VButton.vue";
import {useBatchQr} from "@/scripts/store/batch_qr";
import {BatchQrResult} from "@/scripts/api/qr";
import VWarning from "@/scripts/components/app/common/VWarning.vue";
import VSuccess from "@/scripts/components/app/common/VSuccess.vue";
import BatchSerial from "@/scripts/components/app/qrcodes/batch/Type/BatchSerial.vue";

const currentType = ref(QrBatchType.LINK)

const typeChanged = (type: QrBatchType) => {
    currentType.value = type
}

const qrForm = qrCodeFormStore()
qrForm.initEmptyStyle()

const isStyleBlockOpen = ref(false)
const toggleStyleBlock = () => {
    isStyleBlockOpen.value = !isStyleBlockOpen.value
}

const pixel = ref('')
const isLoading = ref(false)
const result = ref<BatchQrResult | null>()

const batchQr = useBatchQr()

const batchData = ref<QrTable | File>([])

const dataChanged = (data) => {
    batchData.value = data
}

const proceed = async () => {
    isLoading.value = true
    result.value = null

    result.value = await batchQr.saveBatchQr(
        currentType.value,
        batchData.value,
        qrForm.style,
        pixel.value
    ) as BatchQrResult

    isLoading.value = false
}

</script>

<template>
    <div>
        <batch-types-list :type="currentType" @changed="typeChanged"></batch-types-list>
        <div class="mt-4">
            <batch-link v-if="currentType == QrBatchType.LINK" @changed="dataChanged"></batch-link>
            <batch-serial v-if="currentType == QrBatchType.SERIAL_NUMBER" @changed="dataChanged"></batch-serial>
        </div>
        <div class="mt-4">
            <div
                class="w-1/3 border border-gray-100 rounded px-4 py-2 flex justify-between cursor-pointer items-center mt-4 hover:border-indigo-400 hover:border-1"
                @click="toggleStyleBlock">
                <div>Настройте внешний вид QR кода</div>
                <div v-if="isStyleBlockOpen">
                    <ChevronUpIcon class="w-6 h-6" aria-hidden="true"></ChevronUpIcon>
                </div>
                <div v-if="!isStyleBlockOpen">
                    <ChevronDownIcon class="w-6 h-6" aria-hidden="true"></ChevronDownIcon>
                </div>
            </div>
            <div v-if="isStyleBlockOpen" class="flex">
                <div class="w-7/12">
                    <qr-code-style></qr-code-style>
                </div>
                <div class="w-5/12 relative flex justify-center">
                    <qr-code-view class="w-44 sm:w-60"></qr-code-view>
                </div>
            </div>
        </div>

        <div class="mt-2">
            <pixel v-model="pixel"></pixel>
        </div>

        <div v-if="result" class="mt-4">
            <div v-if="result.errors.length > 0">
                <v-warning>
                    <div>
                        Ошибки при создании (последние 20)
                    </div>
                    <ul class="mt-4">
                        <li v-for="error in result.errors">
                            {{ error.row }}: {{ error.error }}
                        </li>
                    </ul>
                </v-warning>
            </div>
            <div v-else>
                <v-success>
                    QR коды успешно созданы: {{ result.createdCount }} шт.
                </v-success>
            </div>
        </div>

        <div class="mt-8">
            <v-button title="Создать" :loading="isLoading" @click="proceed"></v-button>
        </div>
    </div>
</template>